import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmModalData {
  show: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {

  private modalStateSubject = new Subject<ConfirmModalData>();

  modalState = this.modalStateSubject.asObservable();

  open(
    title: string,
    message: string,
    onConfirm: () => void,
    confirmText: string = 'Confirm',
    cancelText: string = 'Cancel'
  ) {
    this.modalStateSubject.next({
      show: true,
      title,
      message,
      confirmText,
      cancelText,
      onConfirm
    });
  }
}